module.exports = __webpack_public_path__ + "img/2x.de5a105.jpg";